import React, {useEffect} from 'react';
import { getFileName } from '../../../helpers/FileCaching';
//import MediaQuery from 'react-responsive';
// styles
import classes from './videoArticlePromos.module.scss'
//import renderHTML from 'react-render-html';
import globalJSON from '../../../data/global.json'
import hubJSON from '../../../data/hub.json';

const videoImages = require.context('../../../images/components/videoArticlePromos', true, /.*\.(gif|png|jpe?g|svg)$/i);

const data = hubJSON.videoArticlePromos;

function promoLoop(content){

    function onClick(videoData){
		window.gtag('event', "video selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "video clicked "+ videoData.promURL,
			'value':10
		});
    }
    return(
        <div className={classes.videoArticlePromos__promos}>
            {content.videoPromos.map( (newpromo, index) => {
                return(
                    <div key={index} className={classes.videoArticlePromos__promos__promo_container}>
                        <div className={`${classes.videoArticlePromos__promos__promo}`}>
                            <a href={newpromo.promoURL} onClick={onClick}>
                                <div className={classes.videoArticlePromos__promos__image_container}>
                                    <img className={classes.videoArticlePromos__promos__image} src={getFileName(videoImages,newpromo.image)} alt={newpromo.imageAlt}/>
                                    <img className={classes.videoArticlePromos__promos__play_button} src={getFileName(videoImages, data.playButton)} alt={data.playButtonAlt}/> 
                                </div>
                            </a>
                            <div className={classes.videoArticlePromos__promos__content_container}>
                                <a className={classes.videoArticlePromos__promos__link} href={newpromo.promoURL} onClick={onClick}>
                                    <h2 className={classes.videoArticlePromos__promos__title}>{newpromo.title}</h2>
                                </a>
                                <a className={classes.videoArticlePromos__promos__cta_link} href={newpromo.promoURL} onClick={onClick}>
                                    <p className={classes.videoArticlePromos__promos__cta_text}>{data.promoCtaText}</p>
                                </a>
                            </div>
                            <div className={classes.videoArticlePromos__promos__btm_boarder}></div>
                        </div>
                    </div>
                        
                );
            })}
        </div>
    )
}



function VideoArticlePromos({windowSize, content}){

    useEffect(() => {

	},[windowSize])

	return (
		<section id={"videoArticlePromos"} className={classes.videoArticlePromos}>
            <div className={classes.videoArticlePromos__heading}>
                <div className={classes.videoArticlePromos__heading_line_left}></div>
                <h2 className={classes.videoArticlePromos__heading_title}>{data.heading}</h2>
                <div className={classes.videoArticlePromos__heading_line_right}></div>
            </div>
            <div className={classes.videoArticlePromos__videoPromos}>
                {promoLoop(content)}
            </div>
            <div className={classes.videoArticlePromos__container} style={{backgroundImage: `url(${getFileName(videoImages, data.backgroundImage[windowSize])})`}} title={data.backgroundImageAlt}>
            </div>
			
		</section>
		
	)
}

export default VideoArticlePromos;